// 首頁區塊 key，陣列順序即預設順序。
// 與 shop-api service/platform/cms_home_section.go 的 HomeSectionKeys 一致，新增區塊要兩邊一起加。
export const HOME_SECTION_KEYS = [
  'banner_carousel',
  'featured_category',
  'auction_live',
  'live_shopping',
  'middle_banner',
  'hot_brands',
  'for_you',
  'recently_viewed',
  'hot_products',
] as const

export type HomeSectionKey = (typeof HOME_SECTION_KEYS)[number]

const splitKeys = (value?: string) =>
  (value ?? '')
    .split(',')
    .map((key) => key.trim())
    .filter(Boolean)

// 舊 key：「現在直播」「即將直播」已改成「限時競標」「直播購物」，後台舊設定沿用原本的位置與隱藏設定
const LEGACY_SECTION_KEYS: Record<string, HomeSectionKey> = {
  active_lives: 'auction_live',
  upcoming_lives: 'live_shopping',
}

const toCurrentKey = (key: string) => LEGACY_SECTION_KEYS[key] ?? key

const isHomeSectionKey = (key: string): key is HomeSectionKey => (HOME_SECTION_KEYS as readonly string[]).includes(key)

/**
 * 依後台設定算出要顯示的區塊與順序。
 * 不認得的 key 略過；設定裡缺的區塊補在最後（顯示），讓前台先上新區塊也不會消失；沒有設定就是預設順序。
 */
export const getVisibleHomeSections = (params?: { order?: string; hidden?: string } | null): HomeSectionKey[] => {
  const hidden = new Set(splitKeys(params?.hidden).map(toCurrentKey))
  const ordered = [...splitKeys(params?.order).map(toCurrentKey), ...HOME_SECTION_KEYS].filter(isHomeSectionKey)

  return Array.from(new Set(ordered)).filter((key) => !hidden.has(key))
}
